import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'
import BookingsView from '@/features/bookings'

const bookingIdSchema = z.object({ bookingId: z.coerce.number().optional() })

function BookingsRoute() {
  return <BookingsView defaultLayout={undefined} />
}

export const Route = createFileRoute('/_authenticated/dashboard/bookings')({
  component: BookingsRoute,
  validateSearch: zodValidator(bookingIdSchema),
})
